import React from 'react';
import { Seat } from '../../model/ticket';

interface Props {
  seat: Seat;
}

export function SeatInfo({ seat }: Props): JSX.Element {
  return (
    <div>
      {[seat?.venueSection?.name, [seat?.row, seat?.name].filter(Boolean).join(' / ')].filter(Boolean).join(' - ')}
    </div>
  );
}
